import clsx from "clsx"
import { useCallback, useContext, useEffect, useState } from "react"
import { MediaMobile } from "../../../../api/const/MediaQuery"
import useMediaQuery from "../../../../hook/useMediaQuery"
import { AppGeneralContext } from "../../../../shared/GeneralContext/GeneralContext"
import { Button, Loader } from "../../../atoms"
import { MatchDate } from "../../../types/types"
import { DatesForm } from "./DatesForm"
import { StepperDatesHeader } from "./StepperDatesHeader"
import { useGuestView } from "shared/GeneralContext/GuestContext"
import { useAuth } from "shared/auth"

export const SelectFirstDate = (props: any) => {
    const mobile = useMediaQuery(MediaMobile)
    const { matchCallDates, IsLoadingGetStartupbyId, setMatchCallDates, setStartUpById, setDateResponse, resetMatchCallDates, setModalDatesIsOpen, startUpById } = useContext(AppGeneralContext)
    const [date, setDate] = useState<string | Date | undefined>()
    const [isDisabled, setIsDisabled] = useState<boolean>(true)
    const { auth } = useAuth()
    const { canMatch, userGuest } = useGuestView()
    const [isLoading, setIsLoading] = useState<boolean>(true)



    useEffect(() => {
        if (props.currentStep === 1) {
            setIsLoading(true)

            if (!auth) {
                setIsLoading(false)
                return
            }

            if (canMatch === false) {
                setTimeout(() => {
                    setDateResponse({ type: -1, title: "ERROR", message: "There is already a match with this startup" })
                    props.goToStep(5);
                    setIsLoading(false);
                }, 1000)
                return
            }

            if (canMatch === true) {
                setTimeout(() => {
                    props.goToStep(4);
                    setIsLoading(false)
                }, 1000);
                return

            }

            if (canMatch === undefined) {
                setTimeout(() => {
                    setIsLoading(false)
                }, 1000);
                return
            }
        }
    }, [userGuest, startUpById.canMatch, IsLoadingGetStartupbyId])

    useEffect(() => {
        if (props.currentStep === 1) {
            setIsLoading(true)

            if (!auth) {
                setIsLoading(false)
                return
            }

            if (canMatch === false) {
                setTimeout(() => {
                    setDateResponse({ type: -1, title: "ERROR", message: "There is already a match with this startup" })
                    props.goToStep(5);
                    setIsLoading(false);
                }, 1000)
                return
            }

            if (canMatch === true) {
                setTimeout(() => {
                    props.goToStep(4);
                    setIsLoading(false)
                }, 1000);
                return

            }

            if (canMatch === undefined) {
                setTimeout(() => {
                    setIsLoading(false)
                }, 1000);
                return
            }
            setIsLoading(false)
        }
    }, [canMatch])

    const getDate = (finalDate: string | Date) => {


        setDate(finalDate);
        setIsDisabled(false)
    }

    const cancel = () => {
        resetMatchCallDates();
        props.goToStep(1);
        setModalDatesIsOpen(false);
    }


    const save = () => {
        if (date !== undefined) {
            let firstDate: MatchDate[] = [{
                id: "firstDate",
                date: date
            }]

            setMatchCallDates(firstDate)
            props.nextStep()
        }
    }

    return (
        <div className=" mt-3 position-relative">
            <StepperDatesHeader title={"FIRST DATE"} />
            <div className="d-flex flex-column justify-content-between">
                <DatesForm getValue={(date) => { getDate(date) }} />
                <div className={clsx("d-flex pt-4",
                    { "justify-content-end flex-row": !mobile },
                    { "justify-content-center align-items-center flex-column-reverse mb-5": mobile })}>
                    <Button primary text={"CANCEL"} background={"transparent"}
                        color={"black"} borderColor={"var(--black)"}
                        className={clsx("",
                            { "me-4": !mobile },
                            { "mt-4": mobile })}
                        onClick={() => cancel()} />
                    <Button disabled={isDisabled} primary text={"NEXT DATE"} background={"var(--primary)"}
                        color={"white"} borderColor={"var(--primary)"}
                        onClick={() => save()} />
                </div>
            </div>
        </div>
    )

}